import {
  Icon,
  IconIdentifier,
  IndentedTree,
} from '@aus-platform/design-system';
import { entries } from 'lodash';
import { type FeaturesCount, LayerType, FeatureCountLabel } from 'shared/api';

const FeatureTypeLabel = {
  [FeatureCountLabel.Lines]: 'Line',
  [FeatureCountLabel.Points]: 'Point',
  [FeatureCountLabel.Polygons]: 'Polygon',
  [FeatureCountLabel.Textbox]: 'Textbox',
  [FeatureCountLabel.TotalPoints]: 'Total Points',
};

export const FeatureCountTree: React.FC<{
  layerType: LayerType;
  featuresCount: FeaturesCount | undefined;
  visible: boolean;
}> = ({ layerType, featuresCount, visible }) => {
  const isPointCloudLayerType = layerType === LayerType.PointCloud;

  return (
    <IndentedTree visible={visible}>
      {entries(featuresCount)
        .filter(([feature]) =>
          isPointCloudLayerType
            ? feature === FeatureCountLabel.TotalPoints
            : feature !== FeatureCountLabel.TotalPoints,
        )
        .map(([feature, count]) => {
          const iconFeature = isPointCloudLayerType
            ? FeatureCountLabel.Points
            : feature;
          const countDisplay = isPointCloudLayerType
            ? count
            : `${count} item(s)`;

          return (
            <div className="feature-count-item" key={feature}>
              <Icon
                identifier={IconIdentifier[FeatureTypeLabel[iconFeature]]}
                className="feature-count__icon"
              />
              <div className="feature-count__content">
                <div>{FeatureTypeLabel[feature]}</div>
                <div>{countDisplay}</div>
              </div>
            </div>
          );
        })}
    </IndentedTree>
  );
};
